import { useCallback, useMemo, useState } from 'react';
import { detect } from 'detect-browser';
import printJS from 'print-js';
import { fetchForm } from '../queries/fetchForm';
import { getBlobUrl } from '../../../../../helpers/getBlobUrl';
import { downloadJS } from '../utils/downloadJS';

const browser = detect();
const browsersForPrint = new Set(['yandexbrowser', 'chrome']);
const needPrint = (extension, chunkIdsLength) =>
  browsersForPrint.has(browser?.name) &&
  extension === 'pdf' &&
  chunkIdsLength === 1;

const chunkSize = 200;

export const useOnActionClick = (requestIds) => {
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(
    async (act) => {
      const chunks = Array.from(
        {
          length: Math.ceil(requestIds.length / chunkSize),
        },
        (_, i) => requestIds.slice(i * chunkSize, i * chunkSize + chunkSize)
      );

      setLoading(true);

      const results = await Promise.allSettled(
        chunks.map((chunk) => fetchForm(act, chunk))
      );

      results.forEach((result, index) => {
        if (result.value !== undefined) {
          const { extension, name } = act;

          const url = getBlobUrl(result.value, extension);

          needPrint(extension, chunks.length)
            ? printJS({ printable: url, type: 'pdf' })
            : downloadJS({ ids: chunks[index], name, url });
        }
      });

      setLoading(false);
    },
    [requestIds]
  );

  const data = useMemo(
    () => ({ loading, onActionClick: handleClick }),
    [loading, handleClick]
  );

  return data;
};
